import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @define Expandable.Item
 * Expandable.Item Component
 */
// Vendor
import React from "react"; // local

import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import Header from "../Header";
import uniqueId from "lodash/uniqueId";

var Item = /*#__PURE__*/function (_React$Component) {
  _inherits(Item, _React$Component);

  var _super = _createSuper(Item);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanded: _this.props.isExpanded,
      isAccordion: _this.props.isAccordion
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Item.displayName));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          id = _this$props.id;

      if (onChange && id) {
        return onChange(id);
      }

      _this.setState(function (state) {
        return {
          isExpanded: !state.isExpanded
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "uniqueId", uniqueId("item-"));

    _defineProperty(_assertThisInitialized(_this), "uniqueIdContent", uniqueId("content-"));

    return _this;
  }

  _createClass(Item, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isExpanded !== prevProps.isExpanded) {
        this.setState({
          isExpanded: this.props.isExpanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          header = _this$props2.header,
          title = _this$props2.title,
          headingRank = _this$props2.headingRank,
          id = _this$props2.id,
          className = _this$props2.className,
          itemRef = _this$props2.itemRef,
          dataAnalyticsElementType = _this$props2.dataAnalyticsElementType;
      var _this$state = this.state,
          isExpanded = _this$state.isExpanded,
          isAccordion = _this$state.isAccordion;
      var expandedClassName = this.getClassName({
        descendantName: "content",
        states: "expanded"
      });
      var collapsedClassName = this.getClassName({
        descendantName: "content",
        states: "collapsed"
      });
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          className: className
        }),
        "data-id": id,
        "data-is-expanded": isExpanded,
        "data-heading-rank": headingRank,
        "data-is-accordion": isAccordion,
        "data-rehydratable": getRehydratableName(Item.displayName),
        ref: itemRef
      }, header({
        id: this.uniqueId,
        idContent: this.uniqueIdContent,
        isExpanded: isExpanded,
        isAccordion: isAccordion,
        onClick: this.onClick,
        title: title,
        headingRank: headingRank,
        dataAnalyticsElementType: dataAnalyticsElementType
      }), /*#__PURE__*/React.createElement("div", {
        id: this.uniqueIdContent,
        "aria-labelledby": this.uniqueId,
        className: isExpanded ? expandedClassName : collapsedClassName,
        role: "region"
      }, children));
    }
  }]);

  return Item;
}(React.Component);

_defineProperty(Item, "displayName", "Expandable.Item");

_defineProperty(Item, "defaultProps", {
  header: function header(props) {
    return /*#__PURE__*/React.createElement(Header, props, props.title || "Show More");
  },
  isExpanded: false,
  headingRank: "3",
  isAccordion: false,
  dataAnalyticsElementType: "expandable item"
});

_defineProperty(Item, "Header", void 0);

Item.Header = Header;
export default Item;